module.exports = __webpack_public_path__ + "static/media/ybfDex.57f33dd4.png";